function fire_hydrant() {
    raw_data["fire_hydrant"] ??= ajax_call("geojson/fire/fire_hydrant.geojson")
    var data = raw_data["fire_hydrant"]
    // heatmap config
	var cfg = {
        "radius": 0.004,
        "maxOpacity": .8,
        "scaleRadius": true,
        "useLocalExtrema": false,
        "latField": 'lat',
        "lngField": 'lng',
        "valueField": 'count',
        "gradient": { 0.6: 'cornflowerblue', 0.95: 'lime', 1.0: 'yellow'}
      };
      const fire_hydrant_layer = new HeatmapOverlay(cfg);
      const fire_hydrant_data = data.features.map(el => {
        return { lat: el.geometry.coordinates[1], lng: el.geometry.coordinates[0], count: 0.01 }
      })
      fire_hydrant_layer.setData({max: 0.1, data: fire_hydrant_data});

	return fire_hydrant_layer
}

function narrow_alleys() {
    raw_data["narrow_alleys"] ??= ajax_call("geojson/fire/narrow_alleys.geojson")
    var data = raw_data["narrow_alleys"]
    var previousClickedPolygon = null;
    const result = L.geoJSON(data, {
        style: {
            color: 'black',
            weight: 1,
            opacity: 1,
            fillColor: 'green',
            fillOpacity: 0.5
        },
        onEachFeature: (feature, layer) => {
            layer.bindPopup(
                '<div id="narrow_alleys">' +
                    '<h6>行政區：' + feature.properties.DISTRICT + '</h6>' + 
                    '<h6>管轄分隊：' + feature.properties.POI_TEXT1 + feature.properties.POI_TEXT2 + '</h6>' + 
                    '<h6>道路資訊：' + feature.properties.POI_TEXT3 + '</h6>' + 
                    '<h6>詳細資訊：' + feature.properties.POI_TEXT4 + '</h6>' +
                '</div>'
            )
            layer.on('click', function(e) {
                if (previousClickedPolygon === layer) {
                    layer.setStyle({
                        color: 'black',
                        weight: 1,
                        fillColor: 'green'
                    });
                    previousClickedPolygon = null; // Reset the tracker
                    map.closePopup()
                } else {
                    // If a different polygon is clicked, reset the previous one and style the new one
                    if (previousClickedPolygon) {
                        previousClickedPolygon.setStyle({
                            color: 'black',
                            weight: 1,
                            fillColor: 'green'
                        });
                    }
    
                    // Set the new polygon's style
                    layer.setStyle({
                        color: 'red',
                        weight: 2,
                        fillColor: 'red'
                    });
    
                    previousClickedPolygon = layer; // Update the tracker
                }
            })
        }
    })
    
    return result
}

function dangerous_buildings_cluster () {
    raw_data["dangerous_buildings"] ??= ajax_call("geojson/fire/dangerous_buildings.geojson")
    raw_data["dangerous_buildings"].features.forEach(el => {
		if (el.properties.struct_type == '其他' || el.properties.struct_type == null) {
			el.properties.struct_type = el.properties.struct_type_note
		}
		el.properties.struct_type ??= '其他'
	})
    const data = raw_data["dangerous_buildings"]
    const icon = L.icon({
        iconUrl: "marker_icon/dangerous_buildings.png",
        iconSize: [30, 30],
        iconAnchor: [0, 0], 
        popupAnchor: [10, 10],
    })

    const dangerous_building_layer = L.geoJSON(data,{
        pointToLayer: (feature, latlng) => {
            return L.marker(latlng, { icon })
        },
        filter: (feature, latlng) => {
            if (dangerous_buildings_filter['region']) {
                if (dangerous_buildings_filter['type'] && !dangerous_buildings_filter['location']) {
                    return feature.properties.region == dangerous_buildings_filter['region'] &&
                        feature.properties.struct_type == dangerous_buildings_filter['type']
                } else if (!dangerous_buildings_filter['type'] && dangerous_buildings_filter['location']) {
                    return feature.properties.region == dangerous_buildings_filter['region'] &&
                        feature.properties.location_category == dangerous_buildings_filter['location']
                } else return feature.properties.region == dangerous_buildings_filter['region']
            } else {
                if (dangerous_buildings_filter['type'] && !dangerous_buildings_filter['location']) {
                    return feature.properties.struct_type == dangerous_buildings_filter['type']
                } else if (!dangerous_buildings_filter['type'] && dangerous_buildings_filter['location']) {
                    return feature.properties.location_category == dangerous_buildings_filter['location']
                } else return feature
            }
        },
        onEachFeature: (feature, layer) => {
            layer.bindPopup(`
                <div style="width: 260px;">
                    <h5 style="font-weight: 700">高危險建築物</h5>
                    <h6>搶救計畫編號：${feature.properties.rescue_plan_id}</h6>
                    <h6>名稱：${feature.properties.location_name}</h6>
                    <h6>地址：${feature.properties.address}</h6>
                    <h6>類別：${feature.properties.struct_type}</h6>
                    <h6>位置：${feature.properties.location_category}</h6>
                </div>
            `, {className: 'custom-popup'})
        }
    })
    
    const cluster_layer = L.markerClusterGroup({
        maxClusterRadius: 50,
        iconCreateFunction: (cluster) => {
            return L.divIcon({
                html: `<div>
                    <img src="marker_icon/dangerous_buildings.png" style="width:30px" />
                    <div style="position:absolute; top:20px; left:20px; padding: 0px 5px;
                        border-radius: 10px; color: white; background-color:black"                 
                    >${cluster.getChildCount()}</div>
                </div>`,
                className: 'cluster-police-cctv', // Add a CSS class for styling
                iconSize: new L.Point(30, 30),
            });
        }
    })
    
    return cluster_layer.addLayer(dangerous_building_layer)
}

function dangerous_buildings_heatmap () {
    raw_data["dangerous_buildings"] ??= ajax_call("geojson/fire/dangerous_buildings.geojson")
    var data = raw_data["dangerous_buildings"]

    var cfg = {
        "radius": 0.01,
        "maxOpacity": .8,
        "scaleRadius": true,
        "useLocalExtrema": false,
        "latField": 'lat',
        "lngField": 'lng',
        "valueField": 'count',
        "gradient": { 0.6: 'cornflowerblue', 0.95: 'lime', 1.0: 'yellow'}
    };
    const dangerous_building_layer = new HeatmapOverlay(cfg);
    const dangerous_building_data = data.features.map(el => {
        return { lat: el.geometry.coordinates[1], lng: el.geometry.coordinates[0], count: 0.01 }
    })
    dangerous_building_layer.setData({max: 0.1, data: dangerous_building_data});

    return dangerous_building_layer
}


function get_chemicals() {
    let raw_data = ajax_call(publicPath + "/napi/fire/chemicals")

    return {
        "type": "FeatureCollection",
        "features": raw_data.map(el => ({
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [Number(el.GisX), Number(el.GisY)]
            },
            "properties": {
                ...el,
                region: el.PCompAddr.slice(3,6)
            }
        }))
    }
}

function chemicals_cluster () {
    raw_data["chemicals"] ??= get_chemicals()
    const data = raw_data["chemicals"]
    
    const icon = L.icon({
        iconUrl: "marker_icon/chemical.png",
        iconSize: [30, 30],
        iconAnchor: [0, 0],
        popupAnchor: [10, 10],
    })

    const chemicals_layer = L.geoJSON(data,{
        pointToLayer: (feature, latlng) => {
            return L.marker(latlng, { icon })
        },
        filter: (feature, latlng) => {
            if (chemicals_filter['region']) {
                return feature.properties.region == chemicals_filter['region']
            } else return feature
        },
        onEachFeature: (feature, layer) => {
            layer.bindPopup('<div id="chemicals_area" style="width: 320px">資料連結中...</div>')
        }
    })

    chemicals_layer.on('click', onClick);
    
    function onClick(e) {
        var this_marker = e.layer.feature.properties;
        setTimeout(function(){
            let toxic_chemicals_list = this_marker.toxic_chemicals.map(el => `
                <li>
                    <div class="timeline-panel">
                        <div class="timeline-heading">
                            <h4 class="timeline-title font-weight-bold">毒化物名稱：${el.ATCName}</h4>
                        </div>
                        <div class="timeline-body">
                            <h6>毒化物含量：${el.Qty}</h6>
                            <h6>毒化物經常儲量：${el.Store}</h6>
                            <h6>毒性分類：${el.Class}</h6>
                        </div>
                    </div>
                </li>
            `)
            let toxic_chemicals_html = Array.from(new Set(toxic_chemicals_list)).join('')

            let other_chemicals_list = this_marker.other_chemicals.map(el => `
                <li>
                    <div class="timeline-panel">
                        <div class="timeline-heading">
                            <h4 class="timeline-title font-weight-bold">化學品名稱：${el.ChemicalsName}</h4>
                        </div>
                        <div class="timeline-body">
                            <h6>化學品含量：${el.Qty}</h6>
                            <h6>化學品經常儲量：${el.UStore}</h6>
                            <h6>化學品儲存位置：${el.StoreName}</h6>
                        </div>
                    </div>
                </li>
                
            `)
            let other_chemicals_html = Array.from(new Set(other_chemicals_list)).join('')
            
            $.ajax({
                url: publicPath + '/napi/fire/factory_equipment_map',
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
                },
                dataType: 'json',
                async: false,
                data: JSON.stringify({ Name: this_marker.PCompName }),
            }).done(function(res) {
                this_marker.factory_url = res[0]?.FactoryMap
                this_marker.equipment_url = res[0]?.EquipmentMap
            })
            
            $('#chemicals_area').html(`
                <h5 style="font-weight: 700">毒化物與其他化學品</h5>
                <h6>儲存地點：${this_marker.PCompName}</h6>
                <h6>地址：${this_marker.PCompAddr}</h6>
                <h6>工廠配置圖：${this_marker.factory_url ? `<a href="${this_marker.factory_url}">點擊下載</a>` : '未提供'}</h6>
                <h6>機械配置圖：${this_marker.equipment_url ? `<a href="${this_marker.equipment_url}">點擊下載</a>` : '未提供'}</h6>
                <button type="button" class="btn btn-warning btn-sm" id="chemicals_detail">
                    詳細資料
                </button>
            `);

            $("#chemicals_detail").on('click', function(){
				modal_open(
                    `<div class="d-flex">
                        <div class="container w-50">
                            <ul class="timeline">${toxic_chemicals_html}</ul>
                        </div>
                        <div class="container w-50">
                            <ul class="timeline">${other_chemicals_html}</ul>
                        </div>
                    </div>`,
                    '毒化物與其他化學品儲存資訊：' + this_marker.PCompName
                );
			});
        }, 1000);
    }

    // <hr style="border: 2px solid black"/>
    // ${toxic_chemicals_html}
    // <hr style="border: 2px solid black"/>
    // ${other_chemicals_html}

    const cluster_layer = L.markerClusterGroup({
        maxClusterRadius: 50,
        iconCreateFunction: (cluster) => {
            return L.divIcon({
                html: `<div>
                    <img src="marker_icon/chemical.png" style="width:30px" />
                    <div style="position:absolute; top:20px; left:20px; padding: 0px 5px;
                        border-radius: 10px; color: white; background-color:green"                 
                    >${cluster.getChildCount()}</div>
                </div>`,
                className: 'cluster-police-cctv', // Add a CSS class for styling
                iconSize: new L.Point(30, 30), 
            });
        }
    })

    return cluster_layer.addLayer(chemicals_layer)
}

function chemicals_heatmap () {
    raw_data["chemicals"] ??= get_chemicals()
    var data = raw_data["chemicals"]

    var cfg = {
        "radius": 0.01,
        "maxOpacity": .8,
        "scaleRadius": true,
        "useLocalExtrema": false,
        "latField": 'lat',
        "lngField": 'lng',
        "valueField": 'count',
        "gradient": { 0.6: 'cornflowerblue', 0.95: 'lime', 1.0: 'yellow'}
    };
    const chemicals_layer = new HeatmapOverlay(cfg);
    const chemicals_data = data.features.map(el => {
        return { lat: el.geometry.coordinates[1], lng: el.geometry.coordinates[0], count: 0.01 }
    })
    chemicals_layer.setData({max: 0.1, data: chemicals_data});

    return chemicals_layer
}